<div class="content-bg-white">
    <div class="row">
        <div class="col-md-12">
            <div class="row">
                <p class="label-header"><b>About Us</b></p>
            </div>
            <div class="row">
              <p class="control-label">
                Quotator360.com is a Software provided by Munich Re Underwriting Agents (DIFC) Limited (‘MRUA’), and
                MRUA will retain all interest in and to the Software, including all documentation, modifications,
                improvements, upgrades, derivative words, and all other Intellectual Property rights in connection
                with the Software, including MRUA's (and affiliates) name, logos. and trademarks reproduced through
                the Service.
              </p>
            </div>
            <br />
            <div class="row">
                <div>
                    <p class="control-label">
                        MRUA is a company incorporated in the Dubai International Financial Centre (DIFC), with its
                        registered address at Al Fattan Currency House, Tower 2, Level 4, Dubai, United Arab Emirates,
                        authorised to conduct Insurance Management by the Dubai Financial Services Authority, under the
                        reference number F001207. 
                    </p>
                </div>
            </div>
            <br />
            <div class="row">
                <div>
                    <p class="control-label">
                        MRUA is a  group company of Münchener Rückversicherungs-Gesellschaft Aktiengesellschaft in
                        München (Munich Re), a company incorporated in Germany and regulated by BaFin. Munich Re’s
                        registered address is Königinstrasse 107, 80802 München, Germany. 
                    </p>
                </div>
            </div>
        </div>
    </div> 
</div>
